/**
 * Supabase Offerings/Products Integration
 * Fetch offering data to auto-populate document variables
 */
import { supabase } from '@/lib/supabase-client';
/**
 * Fetch all offerings/products from Supabase
 */
export async function getOfferings() {
    const { data, error } = await supabase
        .from('products')
        .select('*')
        .order('name', { ascending: true });
    if (error) {
        console.error('[getOfferings] Error fetching offerings:', {
            message: error.message,
            details: error.details,
            hint: error.hint,
            code: error.code
        });
        throw error;
    }
    console.log('[getOfferings] Successfully fetched offerings:', {
        count: data?.length || 0,
        offerings: data?.map(d => ({ id: d.id, name: d.name }))
    });
    return data;
}
/**
 * Fetch a single offering by ID
 */
export async function getOffering(offeringId) {
    const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('id', offeringId)
        .single();
    if (error) {
        console.error('Error fetching offering:', error);
        return null;
    }
    return data;
}
/**
 * Convert offering data to document template variables
 * Maps Supabase offering fields to Legal Markdown variable names
 */
export function offeringToVariables(offering) {
    return {
        // Company/Offering Information
        company_name: offering.company_name || 'COW Group of Companies',
        offering_name: offering.name,
        ticker_symbol: offering.ticker_symbol || '',
        contract_address: offering.contract_address || '',
        // Financial Details
        min_investment: offering.min_investment || '',
        minimum_investment: offering.min_investment || '',
        price_per_token: offering.price_per_token || '$1.00',
        total_supply: offering.total_supply || '',
        total_tokens: offering.total_supply || '',
        available_supply: offering.available_supply || '',
        available_tokens: offering.available_supply || '',
        // Returns
        targeted_irr: offering.targeted_irr || '',
        targeted_cash_flow: offering.targeted_cash_flow || '',
        dividend_frequency: offering.dividend_frequency || '',
        // Dates
        effective_date: offering.effective_date || new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }),
        // Wire Instructions (offering-specific)
        account_number: offering.account_number || '',
        routing_number: offering.routing_number || '',
        swift_code: offering.swift_code || '',
        zelle_email: offering.zelle_email || '',
        // Contact
        ir_email: offering.ir_email || 'ir@mycow.io',
        ir_phone: offering.ir_phone || '+1 (702) 509-4063',
        // Currency
        currency: offering.currency || 'USD',
        // Additional offering fields (pass through)
        ...offering
    };
}
